import { render, staticRenderFns } from "./dropdown-multi-checkbox.vue?vue&type=template&id=36ad4516&scoped=true&"
import script from "./dropdown-multi-checkbox.vue?vue&type=script&lang=js&"
export * from "./dropdown-multi-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-multi-checkbox.vue?vue&type=style&index=0&id=36ad4516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ad4516",
  null
  
)

component.options.__file = "dropdown-multi-checkbox.vue"
export default component.exports